import {inject, injectable} from "inversify";
import {ApiCall} from "../api-call";
import {ApiResult} from "../api-result";
import {makeSearchDataQs} from "../../util/str-util";
import {SearchData} from "../types";
import {MnaDealProgressDto} from "./dto/mna-deal-progress-dto";
import { Page } from "../common/dto/page";
import { MnaAdvisorCompanyDto } from "./dto/mna-advisor-company-dto";
import {MnaDealFlowDto} from "./dto/mna-deal-dto";

@injectable()
export class MnaDealApi {
    @inject(ApiCall)
    private apiCall!: ApiCall;

    getMnaDeal = async (searchData: SearchData) => {
        return await this.apiCall.fetch<ApiResult<MnaDealProgressDto[]>>(`/coapi/deal?${makeSearchDataQs(searchData)}`);
    }

    pagingAdvisorCompany = async (pageNo: number, searchData: SearchData) => {
        return await this.apiCall.fetch<ApiResult<Page<MnaAdvisorCompanyDto>>>(`/coapi/deal/company?page=${pageNo}${makeSearchDataQs(searchData)}`);
    }

    getMnaCompanyDealFlow = async (companyId: string) => {
        return await this.apiCall.fetch<ApiResult<MnaDealFlowDto>>(`/coapi/deal/${companyId}`);
    }
}